import { render, staticRenderFns } from "./SalesTaxReportResults.vue?vue&type=template&id=033a2d2d&scoped=true&"
import script from "./SalesTaxReportResults.vue?vue&type=script&lang=js&"
export * from "./SalesTaxReportResults.vue?vue&type=script&lang=js&"
import style0 from "./SalesTaxReportResults.vue?vue&type=style&index=0&id=033a2d2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a2d2d",
  null
  
)

export default component.exports